export default __webpack_public_path__ + "static/media/obelisk.da43d656.png";